import { Link } from "react-router-dom";
import { articles } from "@/mocks/gossip";
import SectionHeading from "@/components/feature/SectionHeading";
import Reveal from "@/components/base/Reveal";

const trending = [...articles].sort((a, b) => b.heat - a.heat).slice(0, 6);
const latest = [...articles].sort((a, b) => (a.date < b.date ? 1 : -1)).slice(0, 4);

export default function TrendingSection() {
  return (
    <section className="mx-auto w-full px-4 py-16 md:px-6 md:py-20 lg:px-10">
      <SectionHeading
        eyebrow="TODAY'S TOP"
        title="今日热瓜榜"
        desc="按 24 小时内阅读、讨论与转发热度综合计算，每小时更新一次排序。"
        linkText="查看完整榜单"
        linkTo="/hot"
      />

      <div className="mt-10 grid grid-cols-1 gap-8 lg:grid-cols-12 lg:gap-10">
        <Reveal className="lg:col-span-8" as="div">
          <ol className="divide-y divide-background-200 border-y border-background-200">
            {trending.map((item, index) => (
              <li key={item.id} className="group flex items-start gap-5 py-5">
                <span
                  className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-md font-heading text-base font-bold ${
                    index < 3
                      ? "bg-accent-500 text-background-50"
                      : "bg-background-200 text-foreground-700"
                  }`}
                >
                  {index + 1}
                </span>
                <div className="min-w-0 flex-1">
                  <div className="mb-2 flex flex-wrap items-center gap-3 text-xs text-foreground-500">
                    <Link
                      to={`/hot?cat=${item.categoryId}`}
                      className="rounded bg-secondary-100 px-2 py-0.5 font-medium text-secondary-900 transition-colors hover:bg-secondary-200"
                    >
                      {item.category}
                    </Link>
                    <span className="flex items-center gap-1">
                      <i className="ri-fire-line text-sm text-accent-500" aria-hidden="true" />
                      热度 {item.heat}
                    </span>
                    <span>{item.date}</span>
                  </div>
                  <h3 className="font-heading text-base font-semibold leading-7 text-foreground-950 transition-colors group-hover:text-primary-700 md:text-lg">
                    <Link to={`/post/${item.id}`}>{item.title}</Link>
                  </h3>
                  <div className="mt-3 h-1.5 w-full max-w-md overflow-hidden rounded-full bg-background-200">
                    <div
                      className="h-full rounded-full bg-primary-500"
                      style={{ width: `${item.heat}%` }}
                      aria-hidden="true"
                    />
                  </div>
                </div>
              </li>
            ))}
          </ol>
        </Reveal>

        <Reveal className="lg:col-span-4" delay={120} as="div">
          <div className="rounded-lg border border-background-200 bg-background-100 p-6">
            <h3 className="flex items-center gap-2 font-heading text-lg font-bold text-foreground-950">
              <i className="ri-inbox-archive-line text-xl text-primary-600" aria-hidden="true" />
              最新投稿
            </h3>
            <p className="mt-2 text-xs text-foreground-500">刚刚通过初筛的线索，等待更多信息补充</p>
            <ul className="mt-5 space-y-4">
              {latest.map((item) => (
                <li key={item.id} className="group flex items-center gap-3">
                  <div className="h-[52px] w-[52px] shrink-0 overflow-hidden rounded-md">
                    <img
                      src={item.cover}
                      alt={item.title}
                      className="h-full w-full object-cover object-top"
                    />
                  </div>
                  <div className="min-w-0">
                    <Link
                      to={`/post/${item.id}`}
                      className="line-clamp-2 text-sm leading-6 text-foreground-800 transition-colors group-hover:text-primary-700"
                    >
                      {item.title}
                    </Link>
                    <p className="mt-1 text-xs text-foreground-500">{item.date}</p>
                  </div>
                </li>
              ))}
            </ul>
            <Link
              to="/submit"
              className="mt-6 flex w-full items-center justify-center gap-1.5 whitespace-nowrap rounded-md bg-foreground-950 px-4 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-add-line text-base" aria-hidden="true" />
              我也要投一条
            </Link>
          </div>
        </Reveal>
      </div>
    </section>
  );
}